import React from 'react'
import clsx from 'clsx'
import styles from './ProgressBar.module.scss'

export interface ProgressBarProps {
    className?: string
    progress: number | undefined
    size: 'sm' | 'md'
}

export const ProgressBar = ({
    className,
    progress = 0,
    size = 'md',
}: ProgressBarProps) => (
    <div className={clsx(styles.progressBarContainer, styles[size], className)}>
        <div className={styles.bar} style={{
            width: `${progress}%`,
        }}>
        </div>
    </div>
)
